(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-footer"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jpc-image-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jpc-image-lightbox')) {
    class JpcImageLightbox extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-jpc-lightbox-index]'));
        this.modal = this.querySelector('[data-jpc-lightbox-modal]');
        this.modalImage = this.querySelector('[data-jpc-lightbox-image]');
        this.prevBtn = this.querySelector('[data-jpc-lightbox-prev]');
        this.nextBtn = this.querySelector('[data-jpc-lightbox-next]');
        this.closeBtn = this.querySelector('[data-jpc-lightbox-close]');
        this.currentIndex = 0;
        this.isOpen = false;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.swipeThreshold = 50;

        if (!this.modal || !this.modalImage || this.triggers.length === 0) return;

        this.onTriggerClick = this.handleTriggerClick.bind(this);
        this.onModalClick = this.handleModalClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onTouchStart = this.handleTouchStart.bind(this);
        this.onTouchEnd = this.handleTouchEnd.bind(this);
        this.onPrev = (event) => {
          event.stopPropagation();
          this.show(this.currentIndex - 1);
        };
        this.onNext = (event) => {
          event.stopPropagation();
          this.show(this.currentIndex + 1);
        };
        this.onClose = (event) => {
          event.stopPropagation();
          this.close();
        };

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', this.onTriggerClick);
        });
        this.modal.addEventListener('click', this.onModalClick);
        this.modal.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.modal.addEventListener('touchend', this.onTouchEnd, { passive: true });
        if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
        if (this.closeBtn) this.closeBtn.addEventListener('click', this.onClose);
      }

      disconnectedCallback() {
        this.triggers.forEach((trigger) => {
          trigger.removeEventListener('click', this.onTriggerClick);
        });
        if (this.modal) {
          this.modal.removeEventListener('click', this.onModalClick);
          this.modal.removeEventListener('touchstart', this.onTouchStart);
          this.modal.removeEventListener('touchend', this.onTouchEnd);
        }
        if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
        if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
        if (this.closeBtn) this.closeBtn.removeEventListener('click', this.onClose);
        document.removeEventListener('keydown', this.onKeydown);
      }

      handleTriggerClick(event) {
        const trigger = event.currentTarget;
        const index = Number(trigger.dataset.jpcLightboxIndex);
        if (Number.isNaN(index)) return;
        this.open(index);
      }

      handleModalClick(event) {
        if (!this.isOpen) return;
        if (event.target.closest('[data-jpc-lightbox-image]')) return;
        if (event.target.closest('.jpc-image-list__control')) return;
        this.close();
      }

      handleTouchStart(event) {
        if (!this.isOpen || !event.changedTouches || !event.changedTouches.length) return;
        this.touchStartX = event.changedTouches[0].clientX;
        this.touchStartY = event.changedTouches[0].clientY;
      }

      handleTouchEnd(event) {
        if (!this.isOpen || !event.changedTouches || !event.changedTouches.length || this.triggers.length < 2) return;

        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - this.touchStartX;
        const deltaY = touch.clientY - this.touchStartY;

        if (Math.abs(deltaX) < this.swipeThreshold) return;
        if (Math.abs(deltaX) < Math.abs(deltaY)) return;

        if (deltaX > 0) {
          this.show(this.currentIndex - 1);
          return;
        }

        this.show(this.currentIndex + 1);
      }

      handleKeydown(event) {
        if (!this.isOpen) return;
        if (event.key === 'Escape') {
          this.close();
          return;
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.currentIndex - 1);
          return;
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.currentIndex + 1);
        }
      }

      open(index) {
        this.isOpen = true;
        this.modal.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKeydown);
        this.show(index);
        if (this.closeBtn) this.closeBtn.focus();
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.modal.removeAttribute('open');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', this.onKeydown);
        const opener = this.triggers[this.currentIndex];
        if (opener) opener.focus();
      }

      show(index) {
        const total = this.triggers.length;
        if (total === 0) return;

        this.currentIndex = ((index % total) + total) % total;
        const trigger = this.triggers[this.currentIndex];
        const src = trigger.dataset.jpcLightboxSrc;
        const alt = trigger.dataset.jpcLightboxAlt || '';

        if (!src) return;

        this.modalImage.src = src;
        this.modalImage.alt = alt;
      }
    }

    customElements.define('jpc-image-lightbox', JpcImageLightbox);
  }

  } catch(e) { console.error(e); }
})();
})();
